export enum FileActionsTypes {
  READ = "@@FILE read files",
  READ_STATUS = "@@FILE read status",
  UPLOAD = "@@FILE upload",
  UPLOAD_STATUS = "@@FILE upload status",
  DELETE = "@@FILE delete",
  DELETE_STATUS = "@@FILE delete status"
}
